import { render, staticRenderFns } from "./PointsProduct.vue?vue&type=template&id=3320bf50&scoped=true"
import script from "./PointsProduct.vue?vue&type=script&lang=js"
export * from "./PointsProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3320bf50",
  null
  
)

export default component.exports